import { getButtonFocusOverrideStyle } from './common-styles';

export const getBackMenuItemStyles = (backMenuItem, { palette = {} }) => ({
  backButton: {
    height: 36,
    textAlign: 'left',
    alignItems: 'center',
    '&:focus': getButtonFocusOverrideStyle(palette.neutralSecondary),
  },
  backIcon: {
    fontSize: '14px !important',
    color: palette.themePrimary,
    margin: '0px !important',
  },
  backTextDiv: {
    position: 'relative',
    height: 36,
    marginLeft: 8,
    fontFamily: 'Segoe UI',
    fontSize: 14,
    display: 'inline-block',
    flexDirection: 'row',
    top: 0,
  },
  backTextContainer: {
    display: 'inline-block',
    marginTop: 8,
    fontSize: 14,
    fontWeight: 'normal',
  },
});
